import React, { Component } from "react";
import { v4 as uuidv4 } from "uuid";
import {
  Card,
  CardBody,
  Col,
  Nav,
  NavItem,
  Row,
  TabContent,
  TabPane,
} from "reactstrap";
import axios from "axios";
import { END_POINT } from "../../../constants/defaultValues";
import {
  SetItemsSelected,
  NotificatioErrController,
  NotificatioSucController,
} from "../../../helpers/Utils";import createSocket from "../../../helpers/createSocket";
import {
  PageHeading,
  WarehouseImportApplicationMenu,
  ListItemLeftForm,
  ListItemFormMobile,
  FooterWarehouseImport,
  AddWarehouseImport,
  UpdateWarehouseImport,
  CameraImportModal,
} from "../../../containers/pages/warehouse-import";
import { Pagination } from "../../../containers/pages/general";
import LogsHelper from "../../../helpers/Logs";
import IntlMessages from "../../../helpers/IntlMessages";
import classnames from "classnames";
import { isC, isR, isU, isD } from "../../../helpers/Roles";
import { NavLink } from "react-router-dom";
import { Separator } from "../../../components/common/CustomBootstrap";
import FooterPage from "../../../containers/pages/FooterPage";
import ContentMultiForm from "../../../containers/pages/warehouse-import/ContentMultiForm";
import { connect } from "react-redux";
import { setSearchContext } from "../../../redux/actions";
import WarehouseImportModernDashboard from "../../../containers/pages/warehouse-import/WarehouseImportModernDashboard";
import StockInWorkspace from "../../../containers/pages/warehouse-import/StockInWorkspace";

const DEFAULT_FORM = {
  id: "",
  name: "",
  phone: "",
  address: "",
  stock: "",
  stock_id: null,
  code: "",
  unit: "",
  quantity: "",
  price: "",
  status: "",
  time: "",
  user: {},
  dynamic_form: [],
};

const ROLE_ALIAS = "warehouseImport";

class ContentComponent extends Component {
  constructor(props) {
    super(props);

    this.state = {
      page: {
        pageSizes: [12, 24],
        selectedPageSize: 12,
        currentPage: 1,
        totalPage: 1,
        totalItem: 0,
        search: "",
      },
      selectedItems: [],
      data: [],
      data_all: [],
      data_stocks: [],

      data_warehouse_import: null,
      filter: null,

      data_dynamic_form: [],
      is_loading_data: true,
      show: {
        add: false,
        update: false,
        view: false,
        viewonly: true,
        cameraImport: false,
      },
      accordion: [],
      activeTab: "1",
      displayMode: "thumblist",
      form: DEFAULT_FORM,
      sku_stock: "",
      is_creating_receipt: false,
      workspaceTab: "dashboard",
      stockInEnabled: false,
      incoming_scanned_items: null,
      is_scanner_from_add: false,
    };

    this.socket = createSocket();
  }

  componentDidMount() {
    this.socket.emit("join room", {
      room_id: localStorage.getItem("user_id"),
    });

    // Set search context cho Navbar
    this.props.setSearchContext("warehouseImport");

    this.dataListRender();
    // this.dataListStockNameRender();
    this.dataAllRender();
    this.dataListRenderStocksUnit();
    this.dataAllRenderStockSoftDel();
    axios.get(`${END_POINT}/stock-in`, {
      headers: { Authorization: `Bearer ${localStorage.getItem("access_token")}` },
      params: { pageSize: 1, currentPage: 1 },
    }).then(() => this.setState({ stockInEnabled: true, workspaceTab: "stockIn" }))
      .catch(() => this.setState({ stockInEnabled: false }));

  }

  componentDidUpdate(prevProps) {
    // Listen thay đổi searchKeyword từ Redux (Navbar search)
    if (prevProps.searchKeyword !== this.props.searchKeyword) {
      this.setState(
        (prev) => ({
          ...prev,
          page: {
            ...prev.page,
            search: this.props.searchKeyword,
          },
        }),
        () => this.dataListRender()
      );
    }
  }

  /** Axios func helper */
  dataListRender = () => {
    const { selectedPageSize, currentPage, search } = this.state.page;

    let tokenStr = localStorage.getItem("access_token");
    axios
      .get(
        `${
          END_POINT + "/warehouse-import/json"
        }?pageSize=${selectedPageSize}&currentPage=${currentPage}&search=${search}`,
        { headers: { Authorization: `Bearer ${tokenStr}` } }
      )
      .then((res) => res.data)
      .then((data) => {
        // console.log('data: ', data);
        let anyAccordion = [];
        let numeroPerguntas = data.data.length;
        for (var i = 0; i < numeroPerguntas; i++) {
          // if (!i) {
          //     anyAccordion.push(true);
          // }
          anyAccordion.push(false);
        }
        this.setState(
          (prev) => ({
            ...prev,
            data: data.data,
            data_dynamic_form: data.dataDynamicForm,
            is_loading_data: false,
            page: {
              ...prev.page,
              totalPage: data.totalPage,
              totalItem: data.totalItem,
            },
            accordion: anyAccordion,
          }),
          () => {
            if (this.state.form.id) {
              const {
                id,
                name,
                phone,
                address,
                stock,
                code,
                unit,
                quantity,
                price,
                status,
                time,
                dynamic_form,
              } = this.state.form;
              this.setState((prev) => ({
                ...prev,
                form: {
                  ...prev.form,
                  id,
                  name,
                  phone,
                  address,
                  stock,
                  code,
                  unit,
                  quantity,
                  price,
                  status,
                  time,
                  dynamic_form,
                },
              }));
            } else {
              this.setState((prev) => ({
                ...prev,
                selectedItems: [],
                show: {
                  ...prev.show,
                  update: false,
                },
                form: DEFAULT_FORM,
              }));
            }
          }
        );
      })
      .catch((err) => {
        this.setState({ is_loading_data: false });
        NotificatioErrController(err.response?.data?.responseText || "Không thể tải danh sách phiếu nhập");
        return false;
      });
  };

  dataAllRender = () => {
    let tokenStr = localStorage.getItem("access_token");
    axios
      .get(`${END_POINT + "/warehouse-import"}`, {
        headers: { Authorization: `Bearer ${tokenStr}` },
      })
      .then((res) => res.data)
      .then((data) => {
        this.setState((prev) => ({
          ...prev,
          data_all: data.data,
        }));
      })
      .catch((err) => {
        NotificatioErrController(err.response?.data?.responseText || "");
        return false;
      });
  };

  dataListRenderStocksUnit = () => {
    let tokenStr = localStorage.getItem("access_token");
    return axios
      .get(`${END_POINT + "/stock/all-unit"}`, {
        headers: { Authorization: `Bearer ${tokenStr}` },
      })
      .then((res) => {
        this.setState((prev) => ({
          ...prev,
          data_stocks: res.data.data,
        }));
      })
      .catch((err) => []);
  };

  dataAllRenderStockSoftDel = () => {
    let tokenStr = localStorage.getItem("access_token");
    axios
      .get(`${END_POINT + "/stock/all-soft-del"}`, {
        headers: { Authorization: `Bearer ${tokenStr}` },
      })
      .then((res) => res.data)
      .then((data) => {
        // console.log('dataStockSoftDel: ', data.data);
        const getSKU = data.data.length + 1;
        this.setState((prev) => ({
          ...prev,
          sku_stock: `NVL${getSKU}`,
        }));
      })
      .catch((err) => {
        NotificatioErrController(err.response?.data?.responseText || "");
        return false;
      });
  };

  // dataListStockNameRender = () => {
  //     let tokenStr = localStorage.getItem('access_token');
  //     axios
  //         .get(`${END_POINT + '/stock/stock_name'}`, {
  //             headers: { Authorization: `Bearer ${tokenStr}` },
  //         })
  //         .then((res) => res.data)
  //         .then((data) => {
  //             this.setState(
  //                 (prev) => ({
  //                     ...prev,
  //                     stock_name: data.data,
  //                 })
  //                 // () => this.dataListRender()
  //             );
  //         })
  //         .catch((err) => {
  //             NotificatioErrController(err.response.data.responseText);
  //             return false;
  //         });
  // };

  onHandlerDelete = () => {
    if (!isD(ROLE_ALIAS)) return false;

    let tokenStr = localStorage.getItem("access_token");
    axios
      .delete(`${END_POINT + "/warehouse-import"}`, {
        data: {
          arrayId: this.state.selectedItems,
        },
        headers: { Authorization: `Bearer ${tokenStr}` },
      })
      .then((res) => res.data)
      .then((data) => {
        NotificatioSucController("Thành công");

        this.socket.emit("create logs", {
          user_id: localStorage.getItem("user_id"),
          message: LogsHelper["warehouseImport-delete"],
        });

        this.dataListRender();
        this.dataAllRender();
      })
      .catch((err) => {
        NotificatioErrController(err.response.data.responseText);
        return false;
      });
  };

  onHandlerUpdate = (e) => {
    if (!isU(ROLE_ALIAS)) return false;
    e.preventDefault();

    const {
      id,
      stock,
      stock_id,
      code,
      unit,
      quantity,
      price,
      name,
      phone,
      address,
      time,
      dynamic_form,
    } = this.state.form;

    if (!name || !id) {
      NotificatioErrController("Dữ liệu không hợp lệ");
      return;
    }

    let tokenStr = localStorage.getItem("access_token");
    axios
      .put(
        `${END_POINT + "/warehouse-import"}`,
        {
          id,
          stock,
          stock_id,
          code,
          unit,
          quantity,
          price,
          name,
          phone,
          address,
          time,
          dynamic_form,
        },
        {
          headers: { Authorization: `Bearer ${tokenStr}` },
        }
      )
      .then((res) => res.data)
      .then((data) => {
        NotificatioSucController("Thành công");

        this.socket.emit("create logs", {
          user_id: localStorage.getItem("user_id"),
          message: LogsHelper["warehouseImport-update"],
        });

        this.dataListRender();
        this.dataAllRender();
        this.toggle("update");
      })
      .catch((err) => {
        NotificatioErrController(err.response.data.responseText);
        return false;
      });
  };

  onHandlerAdd = (e) => {
    if (!isC(ROLE_ALIAS)) return false;
    if (e) e.preventDefault();
    if (this.isCreatingReceipt) return false;

    const {
      stock,
      stock_id,
      code,
      unit,
      quantity,
      price,
      name,
      phone,
      address,
      time,
      dynamic_form,
    } = this.state.form;

    if (!stock) {
      NotificatioErrController("Cần phải chọn hoặc thêm mới 1 mặt hàng");
      return;
    }
    // if (!unit) {
    //     NotificatioErrController('Đơn vị tính cần được thêm vào');
    //     return;
    // }
    if (!quantity) {
      NotificatioErrController("Số lượng nhập cần được thêm vào");
      return;
    }
    if (!price) {
      NotificatioErrController("Giá nhập cần được thêm vào");
      return;
    }
    if (!name) {
      NotificatioErrController("Tên người nhập phiếu cần được thêm vào");
      return;
    }
    if (!phone) {
      NotificatioErrController("Số điện thoại cần được thêm vào");
      return;
    }

    // if (findStockEqual) {
    //     return this.onHandlerAddWithEqualStock();
    // } else {
    if (!this.receiptRequestId) this.receiptRequestId = uuidv4();
    this.isCreatingReceipt = true;
    this.setState({ is_creating_receipt: true });
    let tokenStr = localStorage.getItem("access_token");
    axios
      .post(
        `${END_POINT + "/warehouse-import"}`,
        {
          name,
          sku: this.state.sku_stock,
          phone,
          address,
          stock,
          stock_id,
          code,
          unit,
          quantity,
          price,
          time,
          dynamic_form,
          request_id: this.receiptRequestId,
        },
        {
          headers: { Authorization: `Bearer ${tokenStr}` },
        }
      )
      .then((res) => res.data)
      .then((data) => {
        this.receiptRequestId = null;
        NotificatioSucController("Thành công");

        this.socket.emit("create logs", {
          user_id: localStorage.getItem("user_id"),
          message: LogsHelper["warehouseImport-create"],
        });

        this.dataListRender();
        this.dataAllRender();
        this.dataListRenderStocksUnit();
        this.dataAllRenderStockSoftDel();

        // this.toggle('add');
        this.setState((prev) => ({
          ...prev,
          form: { ...DEFAULT_FORM },
        }));
      })
      .catch((err) => {
        NotificatioErrController(err.response?.data?.responseText || "Không thể lưu phiếu nhập");
        return false;
      })
      .finally(() => {
        this.isCreatingReceipt = false;
        this.setState({ is_creating_receipt: false });
      });
    // }
  };

  // onHandlerAddWithEqualStock = () => {
  //     const {
  //         stock,
  //         code,
  //         unit,
  //         quantity,
  //         price,
  //         name,
  //         phone,
  //         address,
  //         time,
  //         dynamic_form,
  //     } = this.state.form;

  //     if (!stock) {
  //         NotificatioErrController('Cần phải chọn hoặc thêm mới 1 mặt hàng');
  //         return;
  //     }
  //     // if (!unit) {
  //     //     NotificatioErrController('Đơn vị tính cần được thêm vào');
  //     //     return;
  //     // }
  //     if (!quantity) {
  //         NotificatioErrController('Số lượng nhập cần được thêm vào');
  //         return;
  //     }
  //     if (!price) {
  //         NotificatioErrController('Giá nhập cần được thêm vào');
  //         return;
  //     }
  //     if (!name) {
  //         NotificatioErrController('Tên người nhập phiếu cần được thêm vào');
  //         return;
  //     }
  //     if (!phone) {
  //         NotificatioErrController('Số điện thoại cần được thêm vào');
  //         return;
  //     }
  //     const findStockEqual = this.state.data_stocks.find(
  //         (d) => d.name === stock
  //     );

  //     // console.log('findStockEqual: ', findStockEqual);

  //     let tokenStr = localStorage.getItem('access_token');
  //     axios
  //         .post(
  //             `${END_POINT + '/warehouse-import'}`,
  //             {
  //                 name,
  //                 sku: this.state.sku_stock,
  //                 phone,
  //                 address,
  //                 stock,
  //                 code,
  //                 unit,
  //                 quantity,
  //                 price,
  //                 time,
  //                 dynamic_form,
  //                 find_stock_equal: findStockEqual,
  //             },
  //             {
  //                 headers: { Authorization: `Bearer ${tokenStr}` },
  //             }
  //         )
  //         .then((res) => res.data)
  //         .then((data) => {
  //             NotificatioSucController('Thành công');

  //             this.socket.emit('create logs', {
  //                 user_id: localStorage.getItem('user_id'),
  //                 message: LogsHelper['warehouseImport-create'],
  //             });

  //             this.dataListRender();
  //             this.dataAllRender();
  //             this.dataAllRenderStockSoftDel();
  //             // this.onHandlerUpdateStockWithImport(findStockEqual.id);

  //             // this.toggle('add');
  //             this.setState((prev) => ({
  //                 ...prev,
  //                 form: {
  //                     ...prev.form,
  //                     form: DEFAULT_FORM,
  //                 },
  //             }));
  //         })
  //         .catch((err) => {
  //             NotificatioErrController(err.response.data.responseText);
  //             return false;
  //         });
  // };

  /** State func helper */
  toggle = (name) => {
    if (name === "add" && !isC(ROLE_ALIAS)) return false;
    if (name === "update" && !isU(ROLE_ALIAS)) return false;

    if (name === "add") this.receiptRequestId = null;
    this.setState((prev) => ({
      ...prev,
      show: {
        ...prev.show,
        update: name === "add" ? false : prev.show.update,
        [name]: !prev.show[name],
      },
      selectedItems: name === "add" ? [] : prev.selectedItems,
      form: name === "add" ? DEFAULT_FORM : prev.form,
    }));
  };

  hideDisplayContent = () => {
    this.setState((prev) => ({
      ...prev,
      show: {
        ...prev.show,
        view: false,
      },
    }));
  };

  onChangeForm = (e, _name) => {
    this.receiptRequestId = null;
    if (_name === "stock" && !e) {
      this.setState((prev) => ({
        form: { ...prev.form, stock: "", stock_id: null, unit: "" },
      }));
      return;
    }
    if (_name === "stock" && e && !e.target) {
      this.setState((prev) => ({
        form: {
          ...prev.form,
          stock: e.value,
          stock_id: e.key || e.id || null,
          unit: e.unit || "",
        },
      }));
      return;
    }
    if (e.target) {
      let {
        target: { name, value },
      } = e;
      this.setState((prev) => ({
        ...prev,
        form: {
          ...prev.form,
          [name]: value,
        },
      }));
    } else {
      this.setState((prev) => ({
        ...prev,
        form: {
          ...prev.form,
          [_name]: e.value,
        },
      }));
    }
  };
  onChangeDynamicForm = (e, _name) => {
    this.receiptRequestId = null;
    if (e.target) {
      let {
        target: { name, value },
      } = e;

      this.setState((prev) => ({
        ...prev,
        form: {
          ...prev.form,
          dynamic_form: {
            ...prev.form.dynamic_form,
            [name]: value,
          },
        },
      }));
    } else {
      let value = e.value ? e.value : e;

      this.setState((prev) => ({
        ...prev,
        form: {
          ...prev.form,
          dynamic_form: {
            ...prev.form.dynamic_form,
            [_name]: value,
          },
        },
      }));
    }
  };

  onSubmitForm = (type) => {
    if (type === "update") {
      this.onHandlerUpdate();
    } else if (type === "add") {
      this.onHandlerAdd();
    }
  };

  onChangePage = (page) => {
    this.setState(
      (prev) => ({
        ...prev,
        page: {
          ...prev.page,
          currentPage: page,
        },
      }),
      () => this.dataListRender()
    );
  };

  onSearchKey = (e) => {
    if (!e) return false;

    if (e.key === "Enter") {
      let value = e.target.value.toLowerCase();
      this.setState(
        (prev) => ({
          ...prev,
          page: {
            ...prev.page,
            search: value,
          },
        }),
        () => this.dataListRender()
      );
    }
  };

  onChangePageSize = (size) => {
    this.setState(
      (prev) => ({
        ...prev,
        page: {
          ...prev.page,
          selectedPageSize: size,
          currentPage: 1,
        },
      }),
      () => this.dataListRender()
    );
  };

  onClickedItem = (item, callback, args) => {
    // Open update modal when clicking on card
    const {
      id,
      name,
      phone,
      address,
      stock,
      code,
      unit,
      quantity,
      price,
      user,
      time,
      at,
      dynamic_form,
    } = item;

    this.setState(
      (prev) => ({
        ...prev,
        show: {
          ...prev.show,
          update: true,
          view: true,
          viewonly: false,
        },
        form: {
          ...prev.form,
          id,
          name,
          phone,
          address,
          stock,
          code,
          unit,
          quantity,
          price,
          user: user ? user.fullname || user.username : "",
          time,
          at,
          dynamic_form,
        },
        selectedItems: [item.id],
      }),
      () => {
        if (callback) callback(args[0], args[1], args[2]);
      }
    );
  };

  onSelectItem = (item) => {
    if (!item) {
      this.setState((prev) => ({
        ...prev,
        selectedItems: [],
        form: DEFAULT_FORM,
        show: {
          ...prev.show,
          view: false,
          update: false,
          viewonly: true,
        },
      }));
      return;
    }

    const {
      id,
      name,
      phone,
      address,
      stock,
      code,
      unit,
      quantity,
      price,
      status,
      user,
      time,
      at,
      dynamic_form,
    } = item;

    this.setState((prev) => ({
      ...prev,
      form: {
        ...prev.form,
        id,
        name,
        phone,
        address,
        stock,
        code,
        unit,
        quantity,
        price,
        status,
        user: user ? user.fullname || user.username : "",
        time,
        at,
        dynamic_form,
      },
      show: {
        ...prev.show,
        view: true,
        update: false,
        viewonly: true,
      },
    }));
  };

  onClickedUpdate = (item) => {
    const {
      id,
      name,
      phone,
      address,
      stock,
      stock_id,
      code,
      unit,
      quantity,
      price,
      user,
      time,
      at,
      dynamic_form,
    } = item;

    this.setState((prev) => ({
      ...prev,
      show: {
        ...prev.show,
        viewonly: false,
        update: true,
      },
      form: {
        ...prev.form,
        id,
        name,
        phone,
        address,
        stock,
        stock_id,
        code,
        unit,
        quantity,
        price,
        time,
        user: user ? user.fullname || user.username : "",
        at,
        dynamic_form,
      },
      selectedItems: [item.id],
    }));
  };

  onClickedDelete = (item) => {
    let selectedSet = SetItemsSelected(
      item.id,
      this.state.selectedItems,
      "require"
    );
    if (window.confirm("Bạn chắc chắn muốn xoá phiếu nhập kho này?")) {
      this.setState(
        (prev) => ({
          ...prev,
          selectedItems: selectedSet,
        }),
        () => this.onHandlerDelete()
      );
    }
  };

  onClickedCheckbox = (id, event) => {
    // Toggle multi-select
    let selectedSet = SetItemsSelected(id, this.state.selectedItems);

    this.setState((prev) => ({
      ...prev,
      selectedItems: selectedSet,
    }));
  };

  toggleAccordion = (tab) => {
    const prevState = this.state.accordion;
    const state = prevState.map((x, index) => (tab === index ? !x : false));
    this.setState({
      accordion: state,
    });
  };

  toggleTab = (tab) => {
    if (this.state.activeTab !== tab) {
      this.setState({
        activeTab: tab,
      });
    }
  };

  filterData = (key, value) => {
    const { data_all } = this.state;
    // console.log('data_all: ', data_all);
    let filteredData = data_all;

    if (key === "fullname") {
      filteredData = data_all.filter((item) => item.user.key === value);
    } else if (key === "price") {
      if (value <= 1000000) {
        filteredData = data_all.filter((item) => Number(item.price) <= 1000000);
      } else if (value >= 10000000) {
        filteredData = data_all.filter(
          (item) => Number(item.price) >= 10000000
        );
      } else {
        filteredData = data_all.filter(
          (item) =>
            Number(item.price) < 10000000 && Number(item.price) > 1000000
        );
      }
    } else if (key === "quantity") {
      if (value <= 10) {
        filteredData = data_all.filter((item) => Number(item.quantity) <= 10);
      } else if (value >= 51) {
        filteredData = data_all.filter((item) => Number(item.quantity) >= 51);
      } else {
        filteredData = data_all.filter(
          (item) => Number(item.quantity) < 51 && Number(item.quantity) > 10
        );
      }
    } else if (key && value) {
      filteredData = data_all.filter((item) => item[key] === value);
    } else if (key === "" || value === "") {
      filteredData = data_all;
    }

    this.setState(({ filter }) => ({
      data: filteredData,
      filter: key && value ? { column: key, value } : null,
    }));
  };

  showAlertApprove = (item) => {
    if (window.confirm('Bạn chắc chắn muốn "Xét duyệt" Phiếu nhập hàng này?')) {
      // const { id } = this.state.form;

      const status = "approve";
      const tokenStr = localStorage.getItem("access_token");
      axios
        .put(
          `${END_POINT + "/warehouse-import/update_status"}`,
          {
            id: item.id,
            status,
          },
          {
            headers: { Authorization: `Bearer ${tokenStr}` },
          }
        )
        .then((res) => res.data)
        .then((data) => {
          NotificatioSucController("Thành công");

          this.socket.emit("create logs", {
            user_id: localStorage.getItem("user_id"),
            message: LogsHelper["warehouseImport-update"],
          });

          this.dataListRender();
          this.dataAllRender();
          // this.toggle('update');
        })
        .catch((err) => {
          NotificatioErrController(err.response.data.responseText);
          return false;
        });
    }
  };

  showAlertReject = (id) => {
    const reason = window.prompt("Lý do từ chối phiếu nhập hàng:");
    if (reason === null) return;
    if (!reason.trim()) {
      NotificatioErrController("Cần nhập lý do từ chối phiếu nhập");
      return;
    }
    if (reason.trim()) {
      const status = "reject";
      const tokenStr = localStorage.getItem("access_token");
      axios
        .put(
          `${END_POINT + "/warehouse-import/update_status"}`,
          {
            id,
            status,
            reason: reason.trim(),
          },
          {
            headers: { Authorization: `Bearer ${tokenStr}` },
          }
        )
        .then((res) => res.data)
        .then((data) => {
          NotificatioSucController("Thành công");

          this.socket.emit("create logs", {
            user_id: localStorage.getItem("user_id"),
            message: LogsHelper["warehouseImport-update"],
          });

          this.dataListRender();
          this.dataAllRender();
          // this.toggle('update');
        })
        .catch((err) => {
          NotificatioErrController(err.response.data.responseText);
          return false;
        });
    }
  };

  changeDisplayMode = (mode) => {
    this.setState((prev) => ({
      ...prev,
      displayMode: mode,
      show: {
        ...prev.show,
        view: false,
      },
    }));
    return false;
  };

  renderLegacy() {
    const { match } = this.props;
    const {
      page,
      selectedItems,
      data,
      data_all,
      data_stocks,
      filter,
      is_loading_data,
      show,
      form,
      accordion,
      displayMode,
      // Dynamic Form
      data_dynamic_form,
    } = this.state;

    // console.log('data: ', data);
    // console.log('data_stocks: ', data_stocks);
    // console.log('stock_name: ', stock_name);
    // console.log('form: ', form);
    // console.log('data_all: ', data_all);
    // const dataRender = data_warehouse_import?.length ? data_warehouse_import : data;
    // console.log(dataRender);

    if (!isR(ROLE_ALIAS))
      return (
        <Card className="text-muted mh-40vh h-100">
          <CardBody className="d-flex justify-content-center align-items-center">
            Bạn không có quyền sử dụng tính năng này!
          </CardBody>
        </Card>
      );

    return is_loading_data ? (
      <div className="loading" />
    ) : (
      <div
        // className={classnames(
        //     'disable-text-selection',
        //     displayMode === 'thumblist' ? 'app-row' : ''
        // )}
        className="app-row disable-text-selection"
      >
        <PageHeading
          heading="warehouse.import"
          setting={page}
          hideSearch={true}
          match={match}
          data={data}
          totalItem={page.totalItem}
          isDisabledAdd={!isC(ROLE_ALIAS)}
          isDisabledDel={!isD(ROLE_ALIAS)}
          isDisabledUpdate={!isU(ROLE_ALIAS)}
          toggleFunc={() => {
            this.toggle("add");
            this.hideDisplayContent();
            this.toggleAccordion();
          }}
          changePageSizeFunc={this.onChangePageSize}
          onSearchKeyFunc={this.onSearchKey}
          onHandlerDelete={() => {
            if (window.confirm("Bạn có chắc chắn muốn xóa bản ghi này?")) {
              this.onHandlerDelete();
            }
          }}
          displayMode={displayMode}
          changeDisplayMode={this.changeDisplayMode}
          selectedItemsLength={selectedItems.length}
        />
        <AddWarehouseImport
          title={<IntlMessages id="warehouse.add-new-modal-title" />}
          isOpen={show.add}
          toggle={() => {
            this.toggle("add");
          }}
          data_dynamic_form={data_dynamic_form}
          values={form}
          data_stocks={data_stocks}
          setting={show}
          onChange={this.onChangeForm}
          onChangeDynamicForm={this.onChangeDynamicForm}
          onSubmit={this.onHandlerAdd}
          isSubmitting={this.state.is_creating_receipt}
        />
        <UpdateWarehouseImport
          title={<IntlMessages id="warehouse.import-title" />}
          onSubmit={this.onHandlerUpdate}
          isOpen={show.update}
          toggle={() => {
            this.toggle("update");
          }}
          data_dynamic_form={data_dynamic_form}
          values={form}
          setting={show}
          onChange={this.onChangeForm}
          onChangeDynamicForm={this.onChangeDynamicForm}
        />
        {data.length === 0 ? (
          <Card className="mt-4 mb-4 mh-53vh">
            <CardBody>Chưa có dữ liệu...</CardBody>
          </Card>
        ) : (
          <>
            <Nav
              tabs
              className="d-flex justify-content-between separator-tabs ml-0 mb-5"
            >
              <NavItem>
                <NavLink
                  className={classnames({
                    active: this.state.activeTab === "1",
                    "nav-link": true,
                  })}
                  onClick={() => this.toggleTab("1")}
                  location={{}}
                  to="#"
                >
                  <IntlMessages id="general.info" />
                </NavLink>
              </NavItem>

              {/* <NavItem>
                                <NavLink
                                    className={classnames({
                                        active: this.state.activeTab === '2',
                                        'nav-link': true,
                                    })}
                                    onClick={() => this.toggleTab('2')}
                                    location={{}}
                                    to='#'
                                >
                                    <span className='mr-2'>
                                        <i className='simple-icon-settings'></i>
                                    </span>
                                    <IntlMessages id='general.setting' />
                                </NavLink>
                            </NavItem> */}
            </Nav>
            <TabContent activeTab={this.state.activeTab} className="mh-53vh">
              <TabPane tabId="1">
                <Row className="content-page__row d-none d-md-flex">
                  <Col
                    xs="12"
                    // sm="12"
                    // md="12"
                    // lg={show.view && displayMode === "thumblist" ? 6 : 12}
                    // xl={show.view && displayMode === "thumblist" ? 6 : 12}
                  >
                    {data?.length ? (
                      displayMode === "thumblist" ? (
                        <>
                          {data?.map((item, idx) => (
                            <ListItemLeftForm
                              onClickedItem={this.onClickedItem}
                              onUpdate={this.onClickedUpdate}
                              onDelete={this.onClickedDelete}
                              onChangeCheckbox={this.onClickedCheckbox}
                              showAlertApprove={this.showAlertApprove}
                              showAlertReject={this.showAlertReject}
                              isDisabledUpdate={!isU(ROLE_ALIAS)}
                              isDisabledDelete={!isD(ROLE_ALIAS)}
                              selectedItems={selectedItems}
                              setting={show}
                              key={idx}
                              idx={idx}
                              item={item}
                            />
                          ))}
                          {/* {data?.length <
                                                    12 ? null : ( */}
                          <Pagination
                            currentPage={page.currentPage}
                            totalPage={page.totalPage}
                            onChangePage={(i) => this.onChangePage(i)}
                          />
                          {/* )} */}
                        </>
                      ) : (
                        <ContentMultiForm data={data_all} />
                      )
                    ) : (
                      <Card className="d-flex justify-content-center align-items-center">
                        <CardBody>Chưa có dữ liệu...</CardBody>
                      </Card>
                    )}
                  </Col>
                  {/* ContentDisplay commented out - không cần hiển thị nữa
                  {show.view ? (
                    <Col xs="12" sm="12" md="12" lg="6" xl="6">
                      <ContentDisplay
                        // data_dynamic_form={data_dynamic_form}
                        values={form}
                        data_stocks={data_stocks}
                      />
                    </Col>
                  ) : null} */}
                </Row>
                <Row className="content-page__row d-block d-md-none mb-4">
                  <Col>
                    {data?.length ? (
                      data?.map((item, idx) => {
                        // console.log(item);
                        return (
                          <div className="d-flex mb-3 card" key={item.id}>
                            <ListItemFormMobile
                              onClickedItem={this.onClickedItem}
                              onUpdate={this.onClickedUpdate}
                              onDelete={this.onClickedDelete}
                              onChangeCheckbox={this.onClickedCheckbox}
                              isDisabledUpdate={!isU(ROLE_ALIAS)}
                              isDisabledDelete={!isD(ROLE_ALIAS)}
                              selectedItems={selectedItems}
                              key={idx}
                              idx={idx}
                              item={item}
                              form={form}
                              accordion={accordion}
                              toggleAccordion={this.toggleAccordion}
                            />
                          </div>
                        );
                      })
                    ) : (
                      <Card className="d-flex justify-content-center align-items-center">
                        <CardBody>Chưa có dữ liệu...</CardBody>
                      </Card>
                    )}
                    {/* {data?.length < 12 ? null : ( */}
                    <Pagination
                      currentPage={page.currentPage}
                      totalPage={page.totalPage}
                      onChangePage={(i) => this.onChangePage(i)}
                    />
                    {/* )} */}
                  </Col>
                </Row>
              </TabPane>
              {/* <TabPane tabId='2'>Setting</TabPane> */}
            </TabContent>
          </>
        )}
        <WarehouseImportApplicationMenu
          data={data_all}
          // data_warehouse_import={data_warehouse_import}
          filter={filter}
          filterData={(key, value) => this.filterData(key, value)}
        />
        <Separator />
        <FooterPage>
          <FooterWarehouseImport />
        </FooterPage>
      </div>
    );
  }

  render() {
    const {
      page,
      selectedItems,
      data,
      data_all,
      data_stocks,
      is_loading_data,
      show,
      form,
      filter,
      data_dynamic_form,
    } = this.state;

    if (!isR(ROLE_ALIAS)) {
      return (
        <Card className="text-muted mh-40vh h-100">
          <CardBody className="d-flex justify-content-center align-items-center">
            Bạn không có quyền sử dụng tính năng này!
          </CardBody>
        </Card>
      );
    }

    if (this.state.stockInEnabled && this.state.workspaceTab === "stockIn") {
      return <StockInWorkspace
        stocks={data_stocks}
        onLegacy={() => this.setState({ workspaceTab: "legacy" })}
        reloadStocks={this.dataListRenderStocksUnit}
      />;
    }

    if (is_loading_data) return <div className="loading" />;

    const selectedItem = form.id
      ? data_all.find((item) => item.id === form.id) ||
        data.find((item) => item.id === form.id) ||
        form
      : data[0] || null;

    return (
      <div className="disable-text-selection">
        <div className="mb-3">
          {this.state.stockInEnabled && <button type="button" className="btn btn-outline-secondary btn-sm" onClick={() => this.setState({ workspaceTab: "stockIn" })}>
            <i className="simple-icon-layers mr-1" /> Chuyển sang bảng kê nhập nhiều mặt hàng
          </button>}
        </div>
        <AddWarehouseImport
          title={<IntlMessages id="warehouse.add-new-modal-title" />}
          isOpen={show.add}
          toggle={() => this.toggle("add")}
          data_stocks={data_stocks}
          onSuccess={() => {
            this.dataListRender();
            this.dataAllRender();
            this.dataListRenderStocksUnit();
          }}
          onOpenScanner={() => {
            this.setState((prev) => ({
              ...prev,
              is_scanner_from_add: true,
              show: {
                ...prev.show,
                add: false,
                cameraImport: true,
              },
            }));
          }}
          incomingScannedItems={this.state.incoming_scanned_items}
          onClearIncomingScannedItems={() => {
            this.setState({ incoming_scanned_items: null });
          }}
        />
        <UpdateWarehouseImport
          title={<IntlMessages id="warehouse.import-title" />}
          onSubmit={this.onHandlerUpdate}
          isOpen={show.update}
          toggle={() => this.toggle("update")}
          data_dynamic_form={data_dynamic_form}
          values={form}
          setting={show}
          onChange={this.onChangeForm}
          onChangeDynamicForm={this.onChangeDynamicForm}
        />
        <CameraImportModal
          isOpen={show.cameraImport}
          applyOnly={this.state.is_scanner_from_add}
          toggle={() => {
            const wasFromAdd = this.state.is_scanner_from_add;
            this.setState((prev) => ({
              ...prev,
              is_scanner_from_add: false,
              show: {
                ...prev.show,
                cameraImport: false,
                add: wasFromAdd ? true : false,
              },
            }));
          }}
          onSuccess={() => {
            this.dataListRender();
            this.dataAllRender();
            this.dataListRenderStocksUnit();
          }}
          onApplyItems={(scannedItems, meta) => {
            const defaultProvider =
              meta?.providerName && meta.providerName !== "Nhập nhanh qua Camera AI"
                ? meta.providerName
                : "";
            const enriched = (scannedItems || []).map((it) => ({
              ...it,
              provider_name: it.provider_name ?? defaultProvider,
            }));
            this.setState((prev) => ({
              ...prev,
              incoming_scanned_items: enriched,
              is_scanner_from_add: false,
              show: {
                ...prev.show,
                cameraImport: false,
                add: true,
              },
            }));
          }}
        />
        <WarehouseImportModernDashboard
          data={data}
          dataAll={data_all}
          page={page}
          filter={filter}
          selectedItems={selectedItems}
          selectedItem={selectedItem}
          canCreate={isC(ROLE_ALIAS)}
          canUpdate={isU(ROLE_ALIAS)}
          canDelete={isD(ROLE_ALIAS)}
          onAdd={() => {
            this.toggle("add");
            this.hideDisplayContent();
          }}
          onCameraImport={() => {
            this.setState((prev) => ({
              ...prev,
              is_scanner_from_add: false,
              show: {
                ...prev.show,
                cameraImport: true,
                add: false,
              },
            }));
            this.hideDisplayContent();
          }}
          onEdit={this.onClickedUpdate}
          onDelete={this.onClickedDelete}
          onApprove={this.showAlertApprove}
          onReject={this.showAlertReject}
          onSelect={this.onSelectItem}
          onToggleSelected={this.onClickedCheckbox}
          onDeleteSelected={() => {
            if (window.confirm("Bạn có chắc chắn muốn xóa các phiếu đã chọn?")) {
              this.onHandlerDelete();
            }
          }}
          onSearch={this.onSearchKey}
          onFilter={this.filterData}
          onChangePage={this.onChangePage}
          onChangePageSize={this.onChangePageSize}
        />
      </div>
    );
  }
}

const mapStateToProps = ({ searchInput }) => {
  const { keyword: searchKeyword } = searchInput;
  return { searchKeyword };
};

export default connect(mapStateToProps, {
  setSearchContext,
})(ContentComponent);
